
import newsavedreportstypes from '../../json/reports/savedreports';
import { getEnvVariable } from '../../modules/environmentalList';
const externaluserloginhistory = {
    "type": "grid",
    "key": "externalusersloginhistorygrid",
    "gridkey": 'externalusersloginhistorygrid',
    "order": 1,
    "options": {
        receiveValues: [{ paramname: 'UserId', valuefromparent: 'UserId' }],
        sidepopupgridheight: true,
        "crud": {
            "read": {
                "get": {
                    "url": getEnvVariable('MasterAdmin') + `/api/ExternalUser/LoginHistory/Grid/` + getEnvVariable('ModuleKey') + '/' + `{UserId}`,
                    "customProps": {
                        "value": "UserId"
                    }
                }
            }
        },
        "back": {
            "routes": [
                {
                    "route": "/companies",
                    "routeParams": "routeid",
                },
            ],
        },
        "childGrid": true,
        headerProps: {
            title: "User(s) Login History",
            actions: [
                {
                    type: 'fab',
                    icon: 'clear',
                    name: 'clear',
                    color: 'primary',
                    title: 'Clear Filters',
                    menucolor: '#22a9b3'
                },

                {
                    type: 'menu',
                    icon: 'excel',
                    name: 'excel',
                    color: 'primary',
                    title: 'Export to Excel',
                    menucolor: '#c90685',
                    items: [{
                        name: 'Export Current Page',
                        action: 'filtercurrent'
                    },
                    {
                        name: 'Export All Pages',
                        action: 'filterall'
                    }
                    ]
                },

            ]
        },
        savedreports: {
            ...newsavedreportstypes
        },
        "gridcolumns": [
            {
                "title": "IP Address",
                "field": "Ip",
                "show": true,
                //width: 80,
            },
            {
                "title": "Is Success",
                "field": "IsSuccessDesc",
                "show": true,
                //width: 60,
            },
            {
                "title": "Login Date",
                "field": "LoginDate",
                "show": true,
               // width: 100,
            }
        ]
    }
}
export default externaluserloginhistory